import React from 'react'

import { ChatType } from 'services/chat.service'
import { useConversations } from 'hooks'
import UnreadMessagesCount from './UnreadMessagesCount'

const DiscussionsConversationsUnreadMessagesCount = () => {
  const { loading, conversationIds } = useConversations(ChatType.groupDiscussion)

  if (loading || !conversationIds) {
    return null
  }

  return <UnreadMessagesCount conversationIds={conversationIds} />
}

export default DiscussionsConversationsUnreadMessagesCount
